// extracted by mini-css-extract-plugin
module.exports = {"title":"_1nCsa-","icon":"KHpWuR mz-interactive-info-block__icon"};